module.exports = __webpack_public_path__ + "img/s2-v2.f9863f81.png";